<template>
  <div class="dialog-step">
    <div class="container">
      <img class="illustration" src="@/assets/lp-illustration.svg" />
      <div class="content">
        <span>{{ $t('dialogs.getLpTokensTitle') }}</span>
        <span>{{ $t('dialogs.getLpTokensDescription') }}</span>
      </div>
    </div>
    <div class="gradient-border">
      <div class="field-checkbox">
        <PCheckbox v-model="checked" :binary="true" input-id="binary" />
        <label for="binary">{{ $t('dialogs.dontShowAgain') }}</label>
      </div>
    </div>
    <div class="footer">
      <PButton
        class="w-half align-items-center p-button-outlined justify-content-center circular-button"
        @click="onClose"
      >
        <span class="font-medium">{{ $t('common.cancel') }}</span>
      </PButton>
      <PButton
        v-if="account"
        class="w-half align-items-center justify-content-center circular-button p-button-primary"
        @click="goAddLiquidity"
      >
        <span class="font-medium">{{ $t('addLiquidity.title') }}</span>
      </PButton>
      <PButton
        v-else
        class="w-half align-items-center justify-content-center circular-button p-button-primary"
        @click="onConnectWallet"
      >
        <span class="font-medium">{{ $t('common.connectWallet') }}</span>
      </PButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { showInstallMobileAppDialogByOS } from '@/composables/useDialogService';
import router from '@/router';
import { usePoolsStore } from '@/store';
import { useWalletPlugin } from '@/composables/useWalletPlugin';
import { useDialog } from 'primevue/usedialog';
import { computed, inject } from 'vue';

const { account } = useWalletPlugin();
const poolsStore = usePoolsStore();
const dialogRef = inject('dialogRef');

const checked = computed({
  get: () => poolsStore.stakingLpDontShow,
  set: (value) => {
    poolsStore.stakingLpDontShow = value;
  },
});

function goAddLiquidity() {
  router.push({ name: 'pools' });
  onClose();
}

function onClose() {
  dialogRef?.value?.close();
}

const dialog = useDialog();
function onConnectWallet() {
  showInstallMobileAppDialogByOS(dialog);
}
</script>
<style lang="scss" scoped>
$mobile-resolution: 767px;

.container {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 480px;
  .illustration {
    width: 17rem;

    @media screen and (max-width: $mobile-resolution) {
      width: 10rem;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    grid-gap: 8px;
    align-items: center;
    margin-top: 44px;
    margin-bottom: 16px;

    & > span:first-child {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
      letter-spacing: 0.1px;
    }

    & > span:last-child {
      align-items: center;
      text-align: center;
      font-weight: 400;
      font-size: 15px;
      line-height: 24px;
      color: #e5e4fa;
    }
  }

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
  }
}
.footer {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;

  .circular-button {
    border-radius: 100px;

    @media screen and (max-width: $mobile-resolution) {
      font-size: 14px;
    }
  }
}
.gradient-border {
  padding: 0px;
  background: linear-gradient(#6e42ca, #8d29c1);
  border-radius: 8px;
  margin-bottom: 24px;
}
.field-checkbox {
  background: #28253e;
  opacity: 1;
  border-radius: 8px;
  padding: 1rem;
  border: 1px solid #6e42ca;
  margin-bottom: 0px;
  ::v-deep(.p-checkbox-icon) {
    color: white;
  }
  ::v-deep(.p-highlight) {
    background-color: #6e42ca;
    border-color: #6e42ca;
  }
}
</style>
